import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Notification } from '../models/notification.model';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {


	/**
	 * Url to get a list of not processed Notifications
	 */
	private API_NOT_PROCESSED_NOTIFICATIONS_LIST_URL = environment.ipserver + 'o2c-backend/private/messages/listUnprocessed';

	/**
	 * Url to  update Notification status to proccessed
	 */
	private API_UPDATE_NOTIFICATION_STATUS_URL = environment.ipserver + 'o2c-backend/private/messages/process';

	/**
	 * Url to get a Notification by ID
	 */
	private API_GET_NOTIFICATION_BY_ID_URL = environment.ipserver + 'o2c-backend/private/messages/getById';

	// Observable for announcedProcess
	private announcedProcess = new Subject<boolean>();

	// Observable streams
	processAnnounced$ = this.announcedProcess.asObservable();

	constructor(
		private httpClient: HttpClient
	) { }

	/**
	 * Method that announce when a notification was processed
	 * @author Castor Transformación Digital - Fabio Oquendo
	 * @since 2020-01-14
	 */
	public announceProcess(process: boolean) {
		this.announcedProcess.next(process);
	}

	/**
	 * Generates a report with credits registered in DB
	 * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
	 * @since 2020-01-14
	 * @return Observable with an array that contains an invoicing attached documents
	 */
	public list(): Observable<Array<Notification>> {
		return this.httpClient.get<Array<Notification>>(this.API_NOT_PROCESSED_NOTIFICATIONS_LIST_URL);
	}

	/**
	 * Get a notification by ID
	 * @author Castor Transformación Digital
	 * @param notificationId The ID of the notification to retrieve
	 * @return Observable with the notification or null if not found
	 */
	public getNotificationById(notificationId: number): Observable<Notification | null> {
		const params = new HttpParams().set('messageId', notificationId.toString());
		return this.httpClient.get<Notification>(this.API_GET_NOTIFICATION_BY_ID_URL, { params });
	}

	/**
	  * Method to update the status of an EDI Notification (body: array of message IDs, e.g. [123])
	  * Backend may return { processedCount: number } or another format; treat 2xx response as success when no error.
	  */
	public updateStatusNotification(notificationId: number): Observable<boolean> {
		return this.httpClient.put<any>(this.API_UPDATE_NOTIFICATION_STATUS_URL, [notificationId])
			.pipe(
				map((res) => {
					if (res == null) {
						return true;
					}
					if (typeof res.processedCount === 'number') {
						return res.processedCount > 0;
					}
					return true;
				})
			);
	}



}
